import { Link } from 'react-router-dom';

export default function CheckoutCancel() {
  return (
    <div className="aura-page-surface flex min-h-screen flex-col items-center justify-center px-6 text-center text-[#1E1E1E]" data-testid="checkout-cancel-page">
      <h1 className="font-syne text-4xl font-extrabold uppercase tracking-tight md:text-6xl" data-testid="checkout-cancel-title">
        Checkout <span className="steel-text">paused</span>
      </h1>
      <p className="mt-5 max-w-md text-sm font-light leading-relaxed text-[#5C5C5C]">
        Your checkout was cancelled. Your cart is untouched and your pieces are still waiting.
      </p>
      <Link
        to="/shop"
        data-testid="cancel-back-to-shop"
        className="mt-10 inline-block bg-[#1E1E1E] px-10 py-4 font-syne text-xs font-bold uppercase tracking-[0.16em] text-white transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-[#657260]"
      >
        Return to shop
      </Link>
    </div>
  );
}
